import {type ReactElement, useMemo} from 'react'

import {AssigneeQuickFilter, AuthorQuickFilter} from './ActorQuickFilters'
import {LabelQuickFilter, MilestoneQuickFilter, ProjectQuickFilter} from './MetadataQuickFilters'
import type {QuickFilterProps} from './quick-filter-shared'
import {ReviewQuickFilter} from './ReviewQuickFilter'

export function useRepoPullsQuickFilterItems({
  owner,
  query,
  repo,
  onQueryChange,
  showLabels,
  showMilestones,
  showProjects,
  structuralUpdatesEnabled,
}: QuickFilterProps & {
  showLabels: boolean
  showMilestones: boolean
  showProjects: boolean
}): ReactElement[] {
  return useMemo(
    () => [
      <AuthorQuickFilter key="authors" {...{owner, query, repo, onQueryChange, structuralUpdatesEnabled}} />,
      ...(showLabels
        ? [<LabelQuickFilter key="labels" {...{owner, query, repo, onQueryChange, structuralUpdatesEnabled}} />]
        : []),
      ...(showProjects
        ? [<ProjectQuickFilter key="projects" {...{owner, query, repo, onQueryChange, structuralUpdatesEnabled}} />]
        : []),
      ...(showMilestones
        ? [<MilestoneQuickFilter key="milestones" {...{owner, query, repo, onQueryChange, structuralUpdatesEnabled}} />]
        : []),
      <ReviewQuickFilter key="reviews" {...{owner, query, repo, onQueryChange, structuralUpdatesEnabled}} />,
      <AssigneeQuickFilter key="assignees" {...{owner, query, repo, onQueryChange, structuralUpdatesEnabled}} />,
    ],
    [onQueryChange, owner, query, repo, showLabels, showMilestones, showProjects, structuralUpdatesEnabled],
  )
}
